export const homeObjOne = {
    id: "about",
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: "About PEE Token",
    headline: "Create a Safehaven For Token Traders",
    description:
        "Our main goal is to provide people a safe and trustworthy place where they can invest their money. PEE holders can earn Ether rewards by holding a certain amount of the token. As a community developed token, we focus on the needs of our community members. ",
    imgStart: false,
    img: require("../../images/about.svg").default,
    alt: "Car",
    dark: true,
    primary: true,
    darkText: false,
};

export const homeObjTwo = {
    id: "tokenomics",
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: "Tokenomics",
    headline: "Best Tokenomics deal for Holder",
    buttonLabel: "Learn More",
    imgStart: true,
    img: require("../../images/cht.svg").default,
    alt: "PiggyBank",
    dark: false,
    primary: false,
    darkText: true,
    d1: "100.000.000.000 Tokens",
    d2: "2.5% Max Buy",
    d3: "3.5% Max Wallet",
    d4: "8% ETH",
    d5: "2% LP",
    d6: "6% Marketing",
};
